import { useState, useEffect } from 'react';
import { db } from '../../../config/firebase';
import { doc, getDoc } from 'firebase/firestore';

export function useGiftEligibility(productId) {
  const [hasGifts, setHasGifts] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkGiftEligibility = async () => {
      if (!productId) {
        setHasGifts(false);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const docRef = doc(db, 'products', productId);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const data = docSnap.data();
          const giftLevel = data.giftLevel || {};
          
          // Check if any payment period has gift budget > 0
          const hasAnyGifts = Object.keys(giftLevel).some(key => 
            key !== 'currency' && giftLevel[key] > 0
          );
          
          setHasGifts(hasAnyGifts);
        } else {
          setHasGifts(false);
        }
      } catch (error) {
        console.error(`Error checking gift eligibility for ${productId}:`, error);
        setHasGifts(false);
      } finally {
        setLoading(false);
      }
    };

    checkGiftEligibility();
  }, [productId]);

  return { hasGifts, loading };
}
